import { render, staticRenderFns } from "./adas.vue?vue&type=template&id=4a945972"
import script from "./adas.vue?vue&type=script&lang=js"
export * from "./adas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports